import { render, staticRenderFns } from "./AirportForm.vue?vue&type=template&id=60394f42&lang=pug&"
import script from "./AirportForm.vue?vue&type=script&lang=js&"
export * from "./AirportForm.vue?vue&type=script&lang=js&"
import style0 from "./AirportForm.vue?vue&type=style&index=0&id=60394f42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports